import { Id, RequestTicket } from 'src/types'
import api, { Response, make } from '.'

type GetToodoPayTicketsProps = {
  organization_id: Id
  user_id: Id
}
type ResponseToodoPayTickets = any

type SaveToodoPayTicketsProps = {
  organization_id: Id
  tickets: RequestTicket[]
  request_id: Id
}

type ResponseSaveTickets = {
  request_tickets: RequestTicket[]
}

export function getToodoPayTickets(
  props: GetToodoPayTicketsProps
): Promise<Response<ResponseToodoPayTickets>> {
  return make<ResponseToodoPayTickets>({
    axiosCall: api.get(
      `organizations/${props.organization_id}/user/${props.user_id}/toodopay_tickets`
    )
  })
}

export function saveTickets(
  props: SaveToodoPayTicketsProps
): Promise<Response<ResponseToodoPayTickets>> {
  return make<ResponseToodoPayTickets>({
    axiosCall: api.post(
      `/organizations/${props.organization_id}/requests/${props.request_id}/tickets/`, //?toodopay=1`,
      { request_tickets: props.tickets }
    )
  })
}
